import React from 'react';
import { Button, Grid, Link, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { FieldErrors, UseFormMethods } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { routes } from '../common/routes';
import { EmailTextField } from '../common/emailTextField';
import { PasswordTextField } from '../common/passwordTextField';
import { stringConstants } from '../common/strings';
import { LogInFormValues } from '../common/interfaces';
import { SpinnerComponent } from '../common/spinnerComponent';

interface LogInFormProps {
    submitLogIn: (data: LogInFormValues) => void;
    fieldsErrors: FieldErrors;
    handleSubmit: UseFormMethods['handleSubmit'];
    register: UseFormMethods['register'];
    loading: boolean;
}

export const LogInForm = ({ 
    submitLogIn,  
    fieldsErrors, 
    handleSubmit, 
    register,
    loading
}: LogInFormProps) => {
    const { t } = useTranslation();

    return (
        <Grid item xs={12}>
            <form onSubmit={handleSubmit(submitLogIn)}>
                <Grid container item xs={12}>
                    <EmailTextField
                        register={register}
                        fieldsErrors={fieldsErrors}
                        label={t('emailAddress')}
                    />
                </Grid>
                <Grid item xs={12}>
                    <PasswordTextField
                        id={stringConstants.passwordName}
                        name={stringConstants.passwordName}
                        label={t('password')}
                        errorMessage={t('passwordErrorMessage')}
                        register={register}
                        passwordFieldsErrors={fieldsErrors.password}
                        validateFormat={true}
                    />
                </Grid>
                <Grid container item direction='row' alignItems='center' xs={12}>
                    <Grid container item xs={6}>
                        <SignInButton 
                            color='primary' 
                            fullWidth 
                            type='submit' 
                            variant='contained'
                            disableElevation
                        >
                            {t('signIn')}
                            {loading && <SpinnerComponent />}
                        </SignInButton>
                    </Grid>
                    <Grid container item justify='flex-end' xs={6}>
                        <Typography>
                            <ResetPasswordLink 
                                href={routes.resetpassword}
                                rel="noopener noreferrer"
                            >
                                {t('resetPassword')}
                            </ResetPasswordLink>
                        </Typography>
                    </Grid>
                </Grid>
            </form>
        </Grid>
    );
};

const SignInButton = styled(Button)`
    background-color: #0083C6;
`;

const ResetPasswordLink = styled(Link)`
    color: #0083C6;
    font-size: 12px;
`;
